import type { ReactNode } from 'react'
import { TeamioLoader } from './TeamioLoader'

export type CareerWidgetProps = {
	title: string
	teaser: string,
	apiKey: string,
	widgetId: string,
}

export const CareerWidget = ({ title, teaser, apiKey, widgetId }: CareerWidgetProps) => {
	return (
		<div>
			<h2 className="text-h3 md:text-h2 mb-16">{title}</h2>
			<div className="text-odstavec mb-32 max-w-[520px]">{teaser}</div>
			<TeamioLoader apiKey={apiKey} widgetId={widgetId} />
		</div>
	)
}
